export const getRecipientGroupsFromDictionary = (dictionary, ids) => dictionary.filter(group => ids.includes(group.publicId));
